import http from '@/api/http'
import { adminRequest } from '@/entities/admin/api/adminRequest'
import { protectedRequest } from '@/api/protectedRequest'
import { mapCatalogMeta } from '@/entities/catalog/lib/catalogMeta'
import { publicGet } from '@/entities/public/api/publicRequest'

export async function fetchCatalogMeta() {
  try {
    const payload = await publicGet('/public/catalog/meta')
    return mapCatalogMeta(payload.data)
  } catch {
    return mapCatalogMeta()
  }
}

export async function fetchAdminCatalogMeta() {
  try {
    const payload = await adminRequest(() => http.get('/admin/catalog/meta'))
    return mapCatalogMeta(payload.data)
  } catch {
    return fetchCatalogMeta()
  }
}

export async function fetchRestaurantCatalogMeta() {
  try {
    const payload = await protectedRequest(() => http.get('/restaurant/catalog/meta'))
    return mapCatalogMeta(payload.data)
  } catch {
    return fetchCatalogMeta()
  }
}
